export const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuid = (value) => UUID_RE.test(String(value).trim());

/**
 * Normalize formData.cities from legacy string[] or { id, name }[].
 * Legacy entries without id are kept with id: null for admin re-selection.
 */
export const normalizeCities = (cities) => {
  if (!Array.isArray(cities) || cities.length === 0) return [];

  return cities.map((entry) => {
    if (typeof entry === 'string') {
      return { id: null, name: entry.trim() };
    }
    if (entry && typeof entry === 'object') {
      return {
        id: entry.id != null ? String(entry.id) : null,
        name: String(entry.name || '').trim(),
      };
    }
    return null;
  }).filter((c) => c && c.name);
};

/** All cities for lead/OTP forms (name-only or with id) */
export const getDisplayCities = (cities) => normalizeCities(cities);

/** Cities valid for booking dropdown (must have IAM id) */
export const getSelectableCities = (cities) =>
  normalizeCities(cities).filter((c) => c.id != null);

export const findCityById = (cities, cityId) =>
  getSelectableCities(cities).find((c) => String(c.id) === String(cityId));
